import {forwardRef} from 'react';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {DatePicker, DatePickerProps, LocalizationProvider} from '@mui/x-date-pickers';
import {Typography} from '@mui/material';

export interface AppDatePickerProps extends DatePickerProps<Date, any> {
    label: string;
    required?: boolean;
}

const AppDatePicker = forwardRef<HTMLDivElement, AppDatePickerProps>(({label, required, ...rest}, ref) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Typography variant="body2" style={{marginBottom: '5px'}}>
                {label} {required && <span style={{color: 'red'}}>*</span>}
            </Typography>
            <DatePicker
                ref={ref}
                slotProps={{
                    textField: {
                        fullWidth: true,
                        size: 'small',
                    },
                }}
                {...rest}
            />
        </LocalizationProvider>
    );
});

export default AppDatePicker;
